import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subscription, forkJoin } from "rxjs";
import { EmitterService } from "src/app/EmitterService";
import { AppService } from "src/app/app.service";

@Component({
  selector: "contact",
  templateUrl: "./contact.component.html",
  styleUrls: ["./contact.component.scss"],
})
export class ContactComponent implements OnInit, OnDestroy {
  // Event
  showFullContent = false;




 

  toggleShowContent() {
    this.showFullContent = !this.showFullContent;
  }
  // Event
  subscription: Subscription;
  slides = [];
  Notices = [];
  // images = [];
  Notices2 = [];
  ContentData: any;
  loadingData = true;
  HomeContent: any;
  News_event_data: any;
  mission_data: any;
  vission_data: any;
  MainData: any;
  numVisibleCards: number;
  items: string[] = ["photos", "videos"];
  selectedItem: string = "photos";
  VideoAlbums: any;
  VideoAlbumShown = [];
  imageLoaded = false;
  ImageAlbums: any;
  ImageAlbumShown = [];
  GBMessages: any;
  GBMessageShown = [];
  foundnews: any;
  foundAchivements: any;
  randomBackgroundColor: string = "#000000";
  hoverShadowColor: string = "#00000033";
  all_achievement_data: any;

  constructor(
    private emitterService: EmitterService,
    private appService: AppService
  ) {
    // this.Notices2 = JSON.parse(localStorage.getItem('noticeData'));
    this.subscription = this.emitterService.currentMessage.subscribe(
      (message) => {
        if (message === true) {
          let mainData = localStorage.getItem("mainData");

          if (mainData != null) {
            this.MainData = JSON.parse(mainData);
          }
          console.log(this.MainData, "MainData");


          // if (noticeData != null)
          // {
          //   let parsedData: any = JSON.parse(noticeData);

          //   this.Notices = parsedData.filter((x) => x.ShowScroll === true);

          //   this.Notices.sort((a, b) => b.Id - a.Id);

          //   this.loadingData = false;
          // }
          // else
          // {
          //   this.Notices = [];
          //   this.loadingData = false;
          // }

          // console.log(this.Notices, 'this.Notices');
        }
      }
    );
  }


  ngOnInit(): void {
    this.numVisibleCards = window.innerWidth < 768 ? 1 : 3;
    this.FetchData();
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  FetchData() {
    forkJoin([
      this.appService.getNotices(),
      this.appService.getContents(),
      this.appService.getVideoAlbums(),
      this.appService.getImageFolders(),
      this.appService.getGBMessages(),
      this.appService.getSlides(),
    ]).subscribe((response: any) => {
      console.log(response, "response FetchData");

      this.Notices = response[0].data.filter(
        (x) => x.ShowScroll === true && x.IsActive === true
      );

      this.Notices.sort((a, b) => b.Id - a.Id);
      this.Notices = this.Notices.slice(0, 5);



      this.ContentData = response[1].data;
      // To get Welcome Message
      if (this.ContentData != null) {
        let homeContent = this.ContentData.filter(
          (x) => x.MenuCode == 187
        );
        this.HomeContent = homeContent;
        console.log(this.HomeContent, "Home Contebt");
      }



      // To get news event Data
      if (this.ContentData != null) {
        let news = this.ContentData.filter(
          (x) => x.ContentCategoryName == "News And Events"
        );
        this.News_event_data = news;
        this.foundnews = this.News_event_data.slice(0, 3);
        console.log(this.foundnews, "All News Event Data");
      }

      // To get Achievement Data
      if (this.ContentData != null) {
        let achievements_data = this.ContentData.filter(
          (x) => x.ContentCategoryName == "Achievements"
        );
        this.all_achievement_data = achievements_data;
        this.foundAchivements = this.all_achievement_data.slice(0, 3);
        console.log(this.foundAchivements, "All Achievemet Data");
      }

      // To get Mission Data
      if (this.ContentData != null) {
        let news = this.ContentData.filter(
          (x) => x.ContentCategoryName == "Mission"
        );
        this.mission_data = news;
        console.log(this.mission_data, "Misssion Data fsfdf");
      }
      // To get Vission Data
      if (this.ContentData != null) {
        let news = this.ContentData.filter(
          (x) => x.ContentCategoryName == "Vision"
        );
        this.vission_data = news;
        // console.log(this.Vission_data, "Vission Data");
      }
      // New Video Item

      this.VideoAlbums = response[2].data;

      if (this.VideoAlbums != null) {
        for (let i = 0; i < Math.min(3, this.VideoAlbums.length); i++) {
          this.VideoAlbumShown.push(this.VideoAlbums[i]);
        }
      }

      this.ImageAlbums = response[3].data;
      // console.log(this.ImageAlbums, "Noman BHai Image");

      if (this.ImageAlbums != null) {
        for (let i = 0; i < Math.min(3, this.ImageAlbums.length); i++) {
          this.ImageAlbumShown.push(this.ImageAlbums[i]);
        }
      }

      this.GBMessages = response[4].data;
      // console.log(this.GBMessages, "ijhshfdsfjhjsdbhsdhvbsvs");
      let filteredGBM = this.GBMessages.filter((item) =>
        item.Placement.includes("1")
      );
      this.GBMessageShown = filteredGBM.slice(0, 3);
      console.log(this.GBMessageShown, "GBMessageShown");

      this.slides = response[5].data;

      this.loadingData = false;
    });
  }

  TransformUrl(value) {
    if (value.includes("https://")) {
      return value;
    } else {
      return `https://${value}`;
    }
  }

  onNavigate(url: string) {
    let MyUrl = "";
    if (url.startsWith("http://") || url.startsWith("https://")) {
      MyUrl = url;
    } else {
      MyUrl = "https://" + url;
    }
    window.open(MyUrl, "_blank");
  }

  selectItem(item: string) {
    this.selectedItem = item;
  }

  onImageLoad() {
    this.imageLoaded = true;
  }
  // Test truncate starts
  truncateText(text: string, maxLength: number) {
    // Remove HTML tags from the text
    const plainText = text.replace(/<[^>]*>/g, "");

    // Check if the plain text length is greater than the maximum length
    if (plainText.length > maxLength) {
      // Truncate the plain text to the maximum length and append "..." at the end
      return plainText.substring(0, maxLength) + "...";
    } else {
      // If the plain text length is within the maximum length, return the original text
      return text;
    }
  }

  getMessageHref(GBDesignationName: string): string {
    if (GBDesignationName === "Chief Patron") {
      return "/administration/message-of-chief-patron";
    } else if (GBDesignationName === "Chairmen") {
      return "/administration/message-of-chairman";
    } else if (GBDesignationName === "Principal") {
      return "/administration/message-of-principal";
    } else {
      // Default href if none of the conditions match
      return "#";
    }
  }

  // Test truncate ends
}

let imageList = [
  {
    imgSrc: "https://sghscdhaka.edu.bd/assets/img/school/slideImageTop/1.jpg",
    caption: "School Playground",
  },
  {
    imgSrc: "https://sghscdhaka.edu.bd/assets/img/school/slideImageTop/2.jpg",
    caption: "Academic Building",
  },
  {
    imgSrc: "https://sghscdhaka.edu.bd/assets/img/school/slideImageTop/3.jpg",
    caption: "Basket Ball Court",
  },
  {
    imgSrc: "https://sghscdhaka.edu.bd/assets/img/school/slideImageTop/4.jpg",
    caption: "School Playground",
  },
  {
    imgSrc: "https://sghscdhaka.edu.bd/assets/img/school/slideImageTop/5.jpg",
    caption: "School Entrance",
  },
  {
    imgSrc: "https://sghscdhaka.edu.bd/assets/img/school/slideImageTop/6.jpg",
    caption: "School",
  },
];
